/* eslint-disable @typescript-eslint/no-unused-expressions */
import { energyApi } from "utilities/Axios";

export const getAllUnits = () => {
  return energyApi.get("/TagMeta/GetAllUnits");
};

export const getUnitsByTrainId = (trainId = 0) => {
  return energyApi.get(`/TagMeta/GetUnitsByTrainId?id=${trainId}`);
};

export const createUnit = (unit: any) => {
  return energyApi.post("/TagMeta/CreateUnit", unit);
};

export const updateUnit = (unit: any) => {
  return energyApi.post("/TagMeta/UpdateUnit", unit);
};

export const deleteUnit = (id: any) => {
  return energyApi.get(`/TagMeta/DeleteUnit?id=${id}`);
};
